import React from "react";

export default function Loader() {
  return (
    <div style={styles.overlay}>
      
     <img
  src="/images/loaderim.webp"
  alt="Loading..."
  style={{
    width: "120px",
    mixBlendMode: "multiply", // Try 'darken', 'screen', or 'overlay' depending on your page background
  }}
/>

    </div>
  );
}

const styles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(255, 255, 255, 0.8)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 9999,
  },
  loader: {
    width: "120px", // adjust size if needed
    height: "auto",
  },
};
